import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { styled } from '@mui/system';
import axios from 'axios';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper'; 
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import FormControl from '@mui/material/FormControl'; 
import InputLabel from '@mui/material/InputLabel';   
import Select from '@mui/material/Select';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import { jsPDF } from 'jspdf';
import { autoTable } from 'jspdf-autotable';
import Dialog from '@mui/material/Dialog';      
import DialogActions from '@mui/material/DialogActions'; 
import DialogContent from '@mui/material/DialogContent'; 
import DialogTitle from '@mui/material/DialogTitle';  
import logoImage from './images/logo.jpg'; 
import psdfimage from './images/psdfimage.png';
import html2canvas from "html2canvas";
let strcategory=[{title:'',year:0}];
const useStyles = styled({   
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}


function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
export default class Salesrevenuereport extends Component {
	constructor(props) {
    super(props);
		
	   var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
	
	   const currentDate = new Date();
	     var month = (currentDate.getMonth() + 1 < 10) ? "0" + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);

	
this.state = {
	fromdate:new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),fromdate1:currentDate.getFullYear() + '-' + month + '-' + '01',
	todate:Date.now(),todate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),
redirect:false,pagename:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:10,rowsPaging:[],
	 search:'',order:'desc' ,orderBy:'pr_id', SaleData:[],pr_ca_id:'',type:'',CategoryArray:[],cattags:[],
	 ca_id:'',openExportDialog: false,expordata:[],
      }

  this.contentRef = React.createRef();	  
	 };
componentWillMount() {
	document.title = "Isifol - Sales Revenue - Products & Services";	
	  if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
		if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
  this.CategoryBind();
 this.apicall(this.state.page,this.state.rowsPerPage); 			  
		  }
		  else{	    
		this.PageAccessCheckApi();
         }
}
		  
	 let strname="Sales Revenue - Products & Services";
		   
	 this.props.parentdasCallback(
            strname+"~"
        );	
  
	}
	
PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=34')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        	
  this.CategoryBind();
 this.apicall(this.state.page,this.state.rowsPerPage); 
      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}	
apicall(page,rowsPerPage){
  axios.get(localStorage.getItem("ISIurl")+'ajaxsalesrevenuereport.php?action=salerevenuereport&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&pr_ca_id='+this.state.pr_ca_id+'&pr_cmp_id='+localStorage.getItem("ISIcmpid")+'&pr_type='+this.state.type+'&StartIndex='+page+'&PageSize='+rowsPerPage)
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  SaleData: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			});
			this.apiexportcall();
     }
	 else{
		   this.setState({SaleData:[],totaldata:0});
	 }
   
    });

}

apiexportcall(){
  axios.get(localStorage.getItem("ISIurl")+'ajaxsalesrevenuereport.php?action=salerevenuereport&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&pr_ca_id='+this.state.pr_ca_id+'&pr_cmp_id='+localStorage.getItem("ISIcmpid")+'&pr_type='+this.state.type)
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  expordata: resp.data,  
			  
			});
     }
	 else{
		   this.setState({expordata:[],totaldata:0});
	 }
   
    });

}
handleClickSearch=()=>{
 this.apicall(this.state.page,this.state.rowsPerPage); 

} 

  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};

handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };  
  
 handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };
 myChangeHandler = (event) => {
	

	  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  

  this.setState({[nam]: val});

  

} 
 FromdateHandler = (date) => {
     var month = "";
    var dateObj = new Date(date);

       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }
  this.setState({
        fromdate: dayjs(dateObj),
        fromdate1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
    });
}


  
  
TodateHandler = (date) => {
     var month = "";
    var dateObj = new Date(date);

       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }
  this.setState({
        todate: dayjs(dateObj),
       todate1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
    });
} 

oncategoryChange = (event, newTextValue) => {

if(newTextValue!==" "){

  this.setState({ca_id:newTextValue})
}
  
 }
 onTagscategoryChange = (event, values) => {
	  
	   if(values!==" " && values!==null){
		  this.setState({  pr_ca_id:values["year"],cattags:values});
	   }
	  
  }
   CategoryBind() {
    axios.get(localStorage.getItem("ISIurl")+"ajaxcategory.php?action=getall&ca_cmp_id="+localStorage.getItem("ISIcmpid"))
            .then((resp) => {
               
				
				 resp.data.map((row, index) => {
                   
					
					 const items = {
        title:row.ca_name,
          year:row.ca_id,
					 }
					 
					 strcategory.push(items)
                });
				
				
             
                this.setState({CategoryArray: strcategory});
            });
    }
	
 handleOpenExportDialog = () => {
        this.setState({ openExportDialog: true });
    };

    handleCloseExportDialog = () => {
        this.setState({ openExportDialog: false });
    };
	
	
  handleClickOpen = () => {
  
      this.GetLogoForpdf();
  
  };


GetLogoForpdf() {
  axios
    .get(`${localStorage.getItem("ISIurl")}ajaxbusinesssetting.php`, {
      params: {
        action: "getpdflogo",
        bs_cmp_id: localStorage.getItem("ISIcmpid"),
        bs_id: 2,bs_page:5
      },
    })
    .then((resp) => {
      if (resp.data.status === "success") {
        this.setState(
          {
            pdflogo: resp.data.base64,
          },
          () => {
            setTimeout(() => {
              this.handleDownload();
            }, 500);
          }
        );
      } else {
        console.error("Error:", resp.data.message);
      }
    })
    .catch((error) => {
      console.error("Request failed:", error);
    });
}

handleDownload = () => {
   const input = this.contentRef.current;
  if (!input) return;

  html2canvas(input, { scale: 2, backgroundColor: "#ffffff" }).then((canvas) => {
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save('Salesrevenue Report.pdf');
  });

    this.handleCloseExportDialog();
};		
render() {
   if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }

  return (
  
  
<React.Fragment>
<div className="searchbox">
<ul>
<li>  <p> From </p>
  
 <p><LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker']}>
                <DatePicker
                  value={dayjs(this.state.fromdate)}
                  onChange={this.FromdateHandler}
                  format="MM/DD/YYYY"
                  className="txtbox"
				  
                />
			  </DemoContainer>
            </LocalizationProvider></p></li>
			
			  	  <li> 
<p> To </p> 
				<p>   <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker']}>
                <DatePicker
                  value={dayjs(this.state.todate)}
                  onChange={this.TodateHandler}
                  format="MM/DD/YYYY"
                  className="txtbox"
				 
                />
              </DemoContainer>
            </LocalizationProvider></p> </li>

<li>
 <p> Type</p>
                <p>
                 
                    <Select
  native
  variant="outlined" className="txtbox"
  margin="normal"
  fullWidth 
  onChange={this.myChangeHandler}
  id="type"
  value={this.state.type}
  name="type"
  inputProps={{tabIndex: "4"}}
        >
                      <option value="">All</option>
                      <option value={1}>Stock</option>
                      <option value={2}>Non-stock</option>
					  <option value={3}>Service</option>
                   
                    </Select>
                 
                </p>
</li>
<li style={{'width':'20%'}}>
<p>Category</p>
<p>
		   <Autocomplete
      id="custautoextender" 
	  className="txtbox"  inputProps={{ tabIndex: "1" }}
	   inputValue={this.state.ca_id}
	   onInputChange={this.oncategoryChange}
	   onChange={this.onTagscategoryChange}  value={this.state.cattags} 
       options={this.state.CategoryArray}
        renderInput={(params) => (
        <TextField {...params}   variant="outlined" />
      )}
      getOptionLabel={(option) => option.title || ""} />
		  
		  
		  </p></li>
	<li>
<p>&nbsp;</p>
	 <p className="searchbutton">
       <Button
  type="submit"
  variant="contained"
  className="frmSecondarybtn"
  onClick={this.handleClickSearch}
>
 
  Calculate 
</Button>  
                              
</p>
</li>					
</ul>
</div>
<div className="addandbacbtns"> 
<p>&nbsp;</p>
  <Button
                                    variant="contained"
                                    color="primary"
                                    className="exportbtn"
                                    onClick={this.handleOpenExportDialog} 
                                >
                                    EXPORT
                                </Button>
</div>
<div className="clear"> </div>
<div className="estimatebox">
<Paper className={useStyles.root}>
<TableContainer className={useStyles.container}>  
<Table id="salerevenue" stickyHeader aria-label="sticky table"> 
 <TableHead>
          <TableRow>
            
		
            <TableCell>Item Code</TableCell>
        <TableCell>Item Description</TableCell>
		<TableCell>Type</TableCell>
		<TableCell>Qty/Hrs</TableCell>
		<TableCell>Net($)</TableCell>
		<TableCell>Cost($)</TableCell>
		    <TableCell >Profit($)</TableCell>
			   <TableCell >Profit(%)</TableCell>
          </TableRow>
        </TableHead>

 

  <TableBody>

{stableSort(this.state.SaleData, getSorting(this.state.orderBy, this.state.order)).map((item,index) => {  
           return ( <React.Fragment>
 <TableRow key={index} >
<TableCell><a className="link" href={"#/Salesrevenuedetailedreport?prid="+item.pr_id+"&fromdate="+this.state.fromdate1+"&todate="+this.state.todate1}>{item.pr_code}</a></TableCell>
<TableCell><a className="link" href={"#/Salesrevenuedetailedreport?prid="+item.pr_id+"&fromdate="+this.state.fromdate1+"&todate="+this.state.todate1}>{item.description}</a></TableCell>
<TableCell><a className="link" href={"#/Salesrevenuedetailedreport?prid="+item.pr_id+"&fromdate="+this.state.fromdate1+"&todate="+this.state.todate1}>{item.prtype}</a></TableCell>
<TableCell><a className="link" href={"#/Salesrevenuedetailedreport?prid="+item.pr_id+"&fromdate="+this.state.fromdate1+"&todate="+this.state.todate1}>{item.totalqty}</a></TableCell>
<TableCell><a className="link" href={"#/Salesrevenuedetailedreport?prid="+item.pr_id+"&fromdate="+this.state.fromdate1+"&todate="+this.state.todate1}>{'\u200B' + parseFloat(item.totalsaleamt || 0).toFixed(2)}</a></TableCell>
<TableCell><a className="link" href={"#/Salesrevenuedetailedreport?prid="+item.pr_id+"&fromdate="+this.state.fromdate1+"&todate="+this.state.todate1}>{'\u200B' + parseFloat(item.totalcostprice || 0).toFixed(2)}
</a></TableCell>
<TableCell><a className="link" href={"#/Salesrevenuedetailedreport?prid="+item.pr_id+"&fromdate="+this.state.fromdate1+"&todate="+this.state.todate1}>{'\u200B' + parseFloat(item.profitamt || 0).toFixed(2)}</a></TableCell>
 <TableCell><a className="link" href={"#/Salesrevenuedetailedreport?prid="+item.pr_id+"&fromdate="+this.state.fromdate1+"&todate="+this.state.todate1}>{'\u200B' + parseFloat(item.profitpercentage || 0).toFixed(2)}</a></TableCell>

</TableRow>


				</React.Fragment>	
				);
					})}
					
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="9">No Records</TableCell>
					</TableRow>
					) }
					
					
					
 </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[10,20,50, 100, 150,200]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      />    
  </Paper>
  
  </div>
  <div
  ref={this.contentRef}
  style={{
    position: "absolute",
    top: "-10000px",
    left: "-10000px",
    width: "210mm",
    backgroundColor: "#fff",
    opacity: 1,
  }}
>

<div style={{ textAlign: "center", padding: "20px" }}>


<img
  style={{ width: "200px", height: "100px" }}
  src={this.state.pdflogo} 
  alt="Company Logo"
/>

    <h2>Sales Revenue - Products & Services</h2>


	
<Paper className={useStyles.root}>
<TableContainer className={useStyles.container}>  
<Table id="salerevenue" stickyHeader aria-label="sticky table"> 
 <TableHead>
          <TableRow>
            
		
       <TableCell>Item Code</TableCell>
        <TableCell>Item Description</TableCell>
		<TableCell>Type</TableCell>
		<TableCell>Qty/Hrs</TableCell>
		<TableCell>Net($)</TableCell>
		<TableCell>Cost($)</TableCell>
		<TableCell >Profit($)</TableCell>
			   <TableCell >Profit(%)</TableCell>
          </TableRow>
        </TableHead>

 

  <TableBody>

{this.state.expordata.map((item,index) => {  
           return ( <React.Fragment>
 <TableRow key={index} >
<TableCell>{item.pr_code}</TableCell>
<TableCell>{item.description}</TableCell>
<TableCell>{item.prtype}</TableCell>
<TableCell>{item.totalqty}</TableCell>
<TableCell>{'\u200B' + parseFloat(item.totalsaleamt || 0).toFixed(2)}</TableCell>
<TableCell>{'\u200B' + parseFloat(item.totalcostprice || 0).toFixed(2)}</TableCell>
<TableCell>{'\u200B' + parseFloat(item.profitamt || 0).toFixed(2)}</TableCell>
 <TableCell>{'\u200B' + parseFloat(item.profitpercentage || 0).toFixed(2)}</TableCell>

</TableRow>
</React.Fragment>	
				);
})}
					
					
{this.state.totaldata===0 &&(
					
<TableRow key={0} >
<TableCell align="center" colspan="9">No Records</TableCell>
</TableRow>
) }
					
					
					
 </TableBody>


</Table>
  </TableContainer> 
  
  </Paper>
  </div>
</div> 
  <Dialog open={this.state.openExportDialog} onClose={this.handleCloseExportDialog}>
                    <DialogTitle>Sales Revenue - Products & Services Report</DialogTitle>
					
                    <DialogContent>
					<p> To generate a new report, based on the latest selection criteria you've specified, choose the format 
					you want to use. Depending on the amount of data included on the report, it may take some time to generate.</p>
					
                        <p style={{ textAlign: "center", display: "flex", justifyContent: "center", gap: "20px" }}>
						
						<ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className="my-custom-excel-button" 
                    table="salerevenue"
                    filename="Sales Revenue - Products & Services Report"
                    sheet="Sales Revenue - Products & Services Report"
                    buttonText=""
					
					
                />
				
				
				
                        <img
						src={psdfimage}
						width={100}
						height={100}
						style={{ cursor: "pointer" }}
						onClick={this.handleClickOpen}
						alt="Download PDF"
					  />
					
				</p>		
				
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseExportDialog} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
</React.Fragment>
)
}
}
